import './Switch.css';

const Switch = ({
  checked = false,
  onChange,
  disabled = false,
  color = 'primary',
  className = '',
  ariaLabel = 'toggle switch'
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.checked, event);
    }
  };

  return (
    <label className={`switch ${className}`.trim()}>
      <input
        className={`switch-input switch-input-${color}`}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <span className="switch-slider" />
    </label>
  );
};

export default Switch;
